import { useMutation, useQueryClient } from 'react-query';
import { successToast } from 'lib/components/toasts/success';
import { errorToast } from 'lib/components/toasts/error';
import { EXPRESS_API } from 'configs/api/expressApi';
import { TeleprompterResponse } from './types';
import { teleprompterKeys } from './queryKeys';

export interface UpdateTeleprompterScriptRequest {
  title?: string;
  content?: string;
  sharedWithCompany?: boolean;
}

export interface UpdateTeleprompterScriptParams {
  scriptId: string;
  data: UpdateTeleprompterScriptRequest;
}

export const updateTeleprompterScript = async ({
  scriptId,
  data,
}: UpdateTeleprompterScriptParams): Promise<TeleprompterResponse> => {
  const response = await EXPRESS_API.put(`/teleprompter/${scriptId}`, data);
  return response.data;
};

export const useEditTeleprompterScriptMutation = () => {
  const queryClient = useQueryClient();
  return useMutation(updateTeleprompterScript, {
    onSuccess: () => {
      queryClient.invalidateQueries(teleprompterKeys.scripts());
      successToast({
        title: 'Successfully updated script!',
      });
    },
    onError: () => {
      errorToast({ title: 'An error occurred while updating script.' });
    },
  });
};
